import { OriginType } from "../enums/OriginType";
import { RecipeNotificationResult } from "./RecipeNotificationResult";

class RecipeNotification {
  id: number;
  orderId: number;
  description: string;
  originType: OriginType;
  originName: string;
  uniqueIdentificationHash: string;
  createdAt: Date;
  recipeNotificationResults: RecipeNotificationResult[];
}

const RecipeNotificationConstants = {
  LimitNumberOfCustomerNotifications: 4,
  LimitNumberOfSimilarityNotifications: 2
}

export {
    RecipeNotification,
    RecipeNotificationConstants
}